import bosMobileSwitch from '../../assets/common/bos-mobile-switch.svg';
import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const registrationApproval: AppContent['triageDeviceSwitch'] = {
  triageDeviceSwitchContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'Can you switch to a mobile device?',
      content:
        'To register online, we’ll need you to take a photo of your ID and face from a mobile or tablet to confirm your identity.',
      imageAltText: 'BOS banking Mobile device illustration',
      imageSrc: bosMobileSwitch,
      faqHeader: 'Need some help?',
      yesBtn: 'Yes',
      yesBtnHref: '/scan-qr-code',
      noBtn: 'No, I can’t switch',
      noBtnHref: '/three-steps-to-register-for-desktop',
      previousLink: 'Previous',
      previousHref: '/approve-your-registration',
    },
  ],
};

export default registrationApproval;
